// GA4 tracking for the next step under an exam calculator result.
//
// The links come from exam_calculators/_next_step.html.erb (JLPT, TOPIK, EJU,
// BJT, TOEIC) and from ielts_pages/_calculator_plan_link.html.erb (IELTS). Each
// link carries source=<exam>_calculator_<position>, so the click is sent as a
// cta_click whose source_location is that value. The listener sits on the
// document, so no <script> belongs in the views.
import { trackCTAClick } from 'utils/analytics'

const LINK_SELECTOR = '.exam-cta a, [data-ielts-plan-link] a, [data-ielts-teacher-link] a'

// Returns true when the click was sent. A link without a calculator source is
// not a next-step link, so it sends nothing.
export const trackCalculatorNextStepClick = (link) => {
  let url
  try {
    url = new URL(link.href, window.location.origin)
  } catch (error) {
    return false
  }

  const source = url.searchParams.get('source')
  if (!source || !source.includes('_calculator_')) return false

  trackCTAClick('calculator_next_step', source, url.pathname)
  return true
}

const started = new WeakSet()

// One listener per root. A second call does nothing, so a click is never sent
// twice. Returns a function that removes the listener.
export const initCalculatorNextStepTracking = (root = document) => {
  if (started.has(root)) return () => {}

  const onClick = (event) => {
    const link = event.target.closest?.(LINK_SELECTOR)
    if (link) trackCalculatorNextStepClick(link)
  }
  root.addEventListener('click', onClick)
  started.add(root)

  return () => {
    root.removeEventListener('click', onClick)
    started.delete(root)
  }
}
